export default __webpack_public_path__ + "static/media/EM0160.34I-21990_-14985_0.882d5fdf.jpg";